export default {
    rating: {
        please_rate: 'Molim vas ocijenite uslugu (1-5)',
        google_rate: 'Da li biste željeli podijeliti svoje iskustvo i na našem Google poslovnom profilu? ',
        comment: {
            label: 'Komentar',
            placeholder: 'Unesite komentar',
        },
    },
}
